<template>
  <div class="businses_profile profile-page">
    <ProfileHeader :userProfile="userProfileData" />
    <div class="posts-container">
      <h4>{{$t('YoursPosts')}}</h4>
      <div class="wall-post-list">
        <MyProfileCheckinList :userProfile="userProfileData" />
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import VueCookie from "vue-cookie";
import ProfileHeader from "../components/common/ProfileHeader";
import Footer from "../components/common/Footer";
import { toaster } from "../utils/helper";
import { mapMutations } from "vuex";
import MyProfileCheckinList from "../components/MyProfileCheckinList";
Vue.use(VueCookie);

export default {
  name: "Profile",
  components: {
    ProfileHeader,
    Footer,
    MyProfileCheckinList
  },
  data() {
    return {
      userProfileData: {},
      loading: false
    };
  },
  computed: {},
  methods: {
    ...mapMutations(["LoadProfile"]),
      getProfileDetails() {
    this.loading = true;
    this.$store
      .dispatch({ type: "getUserProfile" })
      .then(data => {
        this.userProfileData = data;
        this.loading = false;
        // this.LoadProfile(data);
      })
      .catch(err => {
        toaster(
          this,
          this.$t("wentWrong"),
          "top-center",
          2000
        );
      });
  },
  },
  mounted() {
    this.getProfileDetails();
  }
};
</script>
